// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Wn1nP","footer":"styles_footer__2Qaz2","passCodeTooltip":"styles_passCodeTooltip__JLYgx"};